export default {
  methods: {
    getFileContent: file => new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsText(file, 'UTF-8')
      // eslint-disable-next-line func-names
      reader.onload = function (evt) {
        resolve(evt.target.result)
      }
      // eslint-disable-next-line func-names
      reader.onerror = function () {
        reject()
      }
    }),
    objectToJsonFile: (content, fileName) => {
      let json = JSON.stringify(content)
      json = [json]
      const blob1 = new Blob(json, { type: 'application/json;charset=utf-8' })
      const url = window.URL || window.webkitURL
      const link = url.createObjectURL(blob1)
      const jsonTempEl = document.createElement('a')
      jsonTempEl.download = `${fileName}.json`
      jsonTempEl.href = link
      document.body.appendChild(jsonTempEl)
      jsonTempEl.click()
      document.body.removeChild(jsonTempEl)
    },

  },
}
